import {
  buildProps,
  makeArrayProp,
  makeStringProp,
  numericProp,
} from '@xzx-design/utils'

import { UPDATE_MODEL_EVENT } from '@xzx-design/constants'
import type { ExtractPropTypes } from 'vue'
import type CheckboxGroup from './checkbox-group.tsx'
import type { PropType } from 'vue/dist/vue'
import type { CheckerDirection, CheckerShape } from '../../checkbox/src/types'

export const checkboxGroupProps = buildProps({
  max: {
    type: numericProp,
  },
  shape: makeStringProp<CheckerShape>('round'),
  disabled: Boolean,
  iconSize: {
    type: numericProp,
  },
  direction: {
    type: String as PropType<CheckerDirection>,
  },
  modelValue: makeArrayProp<unknown>(),
  checkedColor: String,
})

export type CheckboxGroupProps = ExtractPropTypes<typeof checkboxGroupProps>
export type CheckboxGroupInstance = InstanceType<typeof CheckboxGroup>

export const checkboxGroupEmits = {
  [UPDATE_MODEL_EVENT]: (value: unknown) => value,
  change: (event: unknown) => event,
}

export type CheckboxGroupEmits = typeof checkboxGroupEmits
